import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ShopContext = createContext(null);

export function ShopProvider({ children }) {
  const [shops, setShops] = useState([]);
  const [selectedShopId, setSelectedShopId] = useState(
    () => localStorage.getItem("rk-shop") || null,
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/shops");
        if (cancelled) return;
        setShops(res.data);
        const stored = localStorage.getItem("rk-shop");
        if (!stored || !res.data.find((s) => s.shop_id === stored)) {
          setSelectedShopId(res.data[0]?.shop_id ?? null);
        }
      } catch {
        setShops([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (selectedShopId) localStorage.setItem("rk-shop", selectedShopId);
  }, [selectedShopId]);

  const selectedShop = shops.find((s) => s.shop_id === selectedShopId) || null;

  return (
    <ShopContext.Provider
      value={{ shops, selectedShopId, setSelectedShopId, selectedShop, loading }}
    >
      {children}
    </ShopContext.Provider>
  );
}

export function useShop() {
  const ctx = useContext(ShopContext);
  if (!ctx) throw new Error("useShop outside provider");
  return ctx;
}
